import React, { useState, useEffect, useRef } from "react";
import { FiSearch, FiX, FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { baseurl, imgurl } from "../../baseurl";
import axios from "axios";

function SearchBar() {
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false); // Mobile Overlay State
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const navigate = useNavigate();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Focus input when mobile overlay opens
  useEffect(() => {
    if (isMobileSearchOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isMobileSearchOpen]);

  // API Call on typing
  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (searchTerm.length > 1) {
        try {
          const res = await axios.get(`${baseurl}searchProductsLookalike?searchTerm=${searchTerm}`);
          if (res.data.success) {
            setResults(res.data.products);
            setShowDropdown(true);
          }
        } catch (err) {
          console.error("Search error", err);
        }
      } else {
        setResults([]);
        setShowDropdown(false);
      }
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const handleSelectProduct = (productName) => {
    setShowDropdown(false);
    setIsMobileSearchOpen(false);
    navigate(`/product/${productName}`);
  };

  return (
    <div className="search-wrapper" ref={dropdownRef}>
      
      {/* 🖥️ Desktop Search Bar (Always visible on desktop, hidden on mobile) */}
      <div className="custom-search-bar desktop-search">
        <input
          type="text"
          placeholder="Search for products..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onFocus={() => searchTerm.length > 1 && setShowDropdown(true)}
        />
        <button className="custom-search-btn">
          <FiSearch size={20} />
        </button>
      </div>

      {/* 📱 Mobile Search Trigger (Only visible on mobile) */}
      <div className="mobile-search-trigger d-md-none" onClick={() => setIsMobileSearchOpen(true)}>
        {/* <FiSearch size={24}  className="text-dark"/> */}

<input type="text" placeholder="Search ...." className="form-control"  />
      </div>

      {/* 🔍 Mobile Search Overlay */}
{/* <div className={`mobile-search-overlay ${isMobileSearchOpen ? "active" : ""}`}>
  <div className="search-header">
    <FiArrowLeft size={24} onClick={() => setIsMobileSearchOpen(false)} />
    <div className="search-input-wrapper">
      <SearchBar />  
    </div>
  </div>
</div> */}



      {/* 📱 Mobile Search Overlay */}
      <div className={`mobile-search-overlay ${isMobileSearchOpen ? "active" : ""}`}>
        <div className="mobile-overlay-header">
          <button className="back-btn" onClick={() => setIsMobileSearchOpen(false)}>
            <FiArrowLeft size={24} />
          </button>
          <input
            ref={inputRef}
            type="text"
            placeholder="Search products..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && (
            <button className="clear-btn" onClick={() => setSearchTerm("")}>
              <FiX size={20} />
            </button>
          )}
        </div>

        <div className="mobile-results-container">
          {results.length > 0 ? (
            results.map((product, index) => (
              <div
                key={index}
                className="search-item"
                onClick={() => handleSelectProduct(product.slug)}
              >
                <div className="item-img">
                  <img src={`${imgurl}${product.image_path}`} alt={product.name} />
                </div>
                <div className="item-details">
                  <div className="item-name">{product.name}</div>
                  <div className="item-cat text-muted">{product.category_name}</div>
                </div>
              </div>
            ))
          ) : searchTerm.length > 1 ? (
            <div className="p-3 text-center text-muted">No results found</div>
          ) : null}
        </div>
      </div>

      {/* 🖥️ Desktop Dropdown */}
      {showDropdown && results.length > 0 && !isMobileSearchOpen && (
        <div className="search-dropdown shadow desktop-only">
          {results.map((product, index) => (
            <div
              key={index}
              className="search-item"
              onClick={() => handleSelectProduct(product.slug)}
            >
              <div className="item-img">
                <img src={`${imgurl}${product.image_path}`} alt={product.name} />
              </div>
              <div className="item-details">
                <div className="item-name">{product.name}</div>
                <div className="item-cat text-muted">{product.category_name}</div>
              </div>
            </div>
          ))}
        </div>
      )}

      <style>{`
        .search-wrapper {
          position: relative;
          width: 100%;
          max-width: 470px;
        }

        /* Desktop UI */
        .desktop-search {
          display: flex;
          align-items: center;
          background: #fff;
          border-radius: 8px;
          overflow: hidden;
          border: 1px solid #ddd;
        }

        .desktop-search input {
          flex: 1;
          border: none;
          padding: 10px 15px;
          outline: none;
        }

        .custom-search-btn {
          background: #ed712f;
          color: white;
          border: none;
          padding: 10px 20px;
          cursor: pointer;
        }

        .search-dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          background: white;
          z-index: 9999;
          border-radius: 0 0 8px 8px;
          max-height: 400px;
          overflow-y: auto;
          display: block !important;
        }

        .search-item {
          display: flex;
          align-items: center;
          padding: 10px;
          border-bottom: 1px solid #eee;
          cursor: pointer;
        }

        .item-img { width: 40px; height: 40px; margin-right: 12px; }
        .item-img img { width: 100%; height: 100%; object-fit: cover; min-width: 45px; border-radius: 4px;}
        .item-name { font-size: 14px; font-weight: 500; color: #333; }
        .item-cat { font-size: 11px; }

        /* Mobile View (Trigger & Overlay) */
        .mobile-search-trigger {
          cursor: pointer;
          display: none;
        }

        .mobile-search-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: #fff;
          z-index: 10000;
          display: flex;
          flex-direction: column;
          transform: translateY(-100%);
          transition: transform 0.3s ease-in-out;
        }

        .mobile-search-overlay.active {
          transform: translateY(0);
        }

        .mobile-overlay-header {
          display: flex;
          align-items: center;
          padding: 10px;
          border-bottom: 1px solid #ddd;
          background: #fff;
        }

        .mobile-overlay-header input {
          flex: 1;
          border: none;
          outline: none;
          padding: 10px;
          font-size: 16px;
        }

        .back-btn, .clear-btn {
          background: none;
          border: none;
          padding: 5px;
          color: #333;
        }

        .mobile-results-container {
          flex: 1;
          overflow-y: auto;
        }

        @media (max-width: 768px) {
          .desktop-search, .desktop-only {
            display: none !important;
          }
          .mobile-search-trigger {
            display: block;
          }
        }

        .mobile-results-container {
  position: fixed; /* Or 'absolute' if it should scroll with the header */
  top: 60px;       /* Adjust based on your header height */
  left: 0;
  right: 0;
  width: 100%;
  
  /* The "Magic" properties */
  z-index: 9999;   /* Ensures it sits on top of all cards, buttons, and images */
  background: #ffffff; /* Crucial: ensures content below doesn't bleed through */
  
  /* Optional: Adds depth to make it look 'elevated' */
  box-shadow: 0 10px 25px rgba(0,0,0,0.15); 
}


      `}</style>
    </div>
  );
}

export default SearchBar;